import baseApi from '@store/api/baseApi';

const assetsApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getArtworks: builder.query({
			query: ({ params }) => ({
				url: 'assets/artwork/all',
				params
			})
		}),
		createArtwork: builder.mutation({
			query: ({ body }) => ({
				url: '/assets/artwork/add',
				method: 'POST',
				body
			})
		}),
		updateArtwork: builder.mutation({
			query: ({ body, id }) => ({
				url: `/assets/artwork/${id}`,
				method: 'PUT',
				body
			})
		}),
		getThemeList: builder.query({
			query: () => ({
				url: '/theme',
				method: 'GET'
			})
		}),
		getSeasonList: builder.query({
			query: () => ({
				url: '/season',
				method: 'GET'
			})
		}),
		getArtworkDetails: builder.query({
			query: ({ artworkId }) => ({
				url: `/assets/artwork/${artworkId}`,
				method: 'GET'
			})
		}),

		getArtworkArtboards: builder.query({
			query: ({ fileName }) => ({
				url: `/artwork-artboard/file?fileName=${fileName}`
			})
		}),

		// Remove DOC
		removeAssetsImage: builder.mutation({
			query: ({ docId, artworkId }) => ({
				url: `/assets/artwork/document/${docId}?artworkId=${artworkId}`,
				method: 'DELETE'
			})
		})
	})
});

export const {
	useGetArtworksQuery,
	useCreateArtworkMutation,
	useUpdateArtworkMutation,
	useGetThemeListQuery,
	useGetSeasonListQuery,
	useGetArtworkDetailsQuery,
	useRemoveAssetsImageMutation,
	useLazyGetArtworkArtboardsQuery
} = assetsApi;
